export interface IRestChatDashboardSettings {
    id?: number;
    enabled?: boolean,
    scope?: EChatDashboardSettingsScope[],
}

export enum EChatDashboardSettingsScope {
    SETTING_ALL = 'all',
    SETTING_WHEN = 'when',
    SETTING_EVENT_I_CREATE_CARD = 'ICreateCard',
    SETTING_I_AM_MENTIONED_IN_COMMENT = 'IAmMentionedInComment',
    SETTING_CARD_ASSIGNED_TO_ME = 'CardAssignedToMe',
    SETTING_I_ADD_COMMENT = 'IAddComment',
}
